export enum ArticleStatus {
  Normal = 'normal',
  Removed = 'removed'
}

export enum ArticleType {
  Article = 'article',
  Page = 'page',
  Evaluation = 'evaluation',
  Logo = 'logo',
  Career = 'career',
  Teammate = 'teammate',
  Faq = 'faq'
}

export interface Article {
  code?: string;
  title?: string;
  creationdate?: string;
  modificationdate?: string;
  type: ArticleType;
  status?: string;
  catalogs?: ArticleCatalog[];
  props?: { [name: string]: any };
}

export interface ArticleCatalog {
  id?: number;
  catalogname?: string;
  parent?: number;
  rank?: number;
  description?: string;
  props?: { [name: string]: string };
}
